import { FC } from "react";
import { API } from "../../services/api/types";
import ProfileImageBig from "./ProfileImageBig";
import ProfileImageSmall from "./ProfileImageSmall";

type ProfileImageProps = {
  person?: API.Player | API.Manager | API.Agent;
  imgSrc: string;
  imageStyle?: string | string[];
  size?: "small" | "big";
  verified?: boolean;
  type?: "player" | "manager" | "agent";
};

const ProfileImage: FC<ProfileImageProps> = ({
  person,
  imgSrc,
  size,
  imageStyle,
  verified,
  type
}) => {
  return size === "small" ? (
    <ProfileImageSmall imgSrc={imgSrc} imageStyle={imageStyle} />
  ) : person ? (
    <ProfileImageBig person={person} imgSrc={imgSrc} verified={verified} type={type} />
  ) : null;
};

export default ProfileImage;
